import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton';
import cn from 'classnames';
import PropTypes from 'prop-types';

import st from './ListItem.module.sass';

export function ListItem({
  icon = undefined,
  label = undefined,
  disabled = false,
  onClick = undefined,
  className = undefined,
}) {
  if (!label) return null;
  const Icon = icon ? React.cloneElement(icon, { className: st.LeftIcon }) : null;

  return (
    <div className={cn(st.ListItem, { [st.Disabled]: disabled }, className)}>
      {Icon}
      <div className={st.StreamName}>{label}</div>
      <IconButton
        className={st.DeleteButton}
        data-testid="ListItem_deleteButton"
        icon={<DeleteIcon />}
        kind="negative"
        onClick={onClick}
        size="small"
        type="button"
        variant="flat"
      />
    </div>
  );
}

ListItem.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};
